import makeStyles from '@mui/styles/makeStyles';
import {Typography} from '@mui/material';

export const useAccordionStyles = makeStyles((theme) => ({
  mainContextRoot: {
    height: '100%',
    flexWrap: 'wrap',
    overflowX: 'hidden',
    padding: '16px 10px',
    alignContent: 'flex-start',
  },
  button: {
    minWidth: 210,
    marginTop: 5,
    marginBottom: 10,
  },
  accordionRoot: {
    flexGrow: 1
  },
  accordionBodyStyle: {
    display: 'flex',
    flexGrow: 1,
    minWidth: '500px',
    overflowY: 'auto',
    paddingTop: 16,
    "& .MuiCollapse-root": {height: 'min-content'}
  },
  activeChip: {
    backgroundColor: theme.palette.primary.main,
  },
  descriptionSection: {
    marginBottom: 10,
  },
  description: {
    marginLeft: 5,
    marginBottom: 8,
    color: theme.palette.mode === 'light' ? '#000' : '#ACAFB3',
  },
  defaultAdmittingSpecSection: {
    marginTop: 10,
    paddingTop: 15,
    borderTop: `2px solid ${theme.palette.background.default}`
  },
  specField: {
    minWidth: 300,
    maxWidth: 310,
  },
  specIcon: {
    backgroundColor: theme.palette.mode === 'light' ? '#D2D5D9' : '#3D3E40',
    borderRadius: 6,
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    fontSize: 'small',
    minHeight: 30,
    maxHeight: 30,
    minWidth: 50,
    padding: '5px 15px',
    cursor: 'pointer',
    '&.active': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  specChip: {
    gap: 5,
    paddingLeft: 8,
    flexBasis: 300,
    cursor: 'pointer',
    maxWidth: 300,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,

    "&:hover": {
      backgroundColor: theme.palette.background.paper,
    }
  },
  emptyCheckbox: {
    color: theme.palette.primary.main,
    transform: 'scale(1.3)',
  }
}));

export const AccordionTabLabel = (props) => (
  <Typography variant="body1" fontWeight={600}>
    {props.children}
  </Typography>
)